import React from "react";
import { Box, Button ,Stack} from "@mui/material";

const ManufactureActionButton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        paddingBottom: "1rem",
        paddingRight: "1rem",
      }}
    >
         <Stack spacing={2} direction="row">
      <Button variant="text">Edit</Button>
      <Button variant="contained">Publish Batch Again</Button>
    </Stack>
    </Box>
  );
};

export default ManufactureActionButton;
